import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { withNamespaces } from "react-i18next";
//Miscellaneous
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import domain from "../../common/data/domain.json";
import { connect } from "react-redux";
import { getUserData } from "../../store/ducks/currentUser/actions";

let dynamicCountry = "malaysia";
if (domain.id.key.includes(window.location.host)) {
  dynamicCountry = "indonesia";
}

class MobileBottomNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: localStorage.getItem("accessToken") ? true : false,
    };
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };


  render() {
    const { t } = this.props;
    const img = this.imageImport(
      require.context(
        "../../assets/images/mobile-bottom-nav/",
        false,
        /\.(png|jpe?g|svg|webp)$/
      )
    );

    return (
      <Auxiliary>
        <section className="bottom-nav-section">
          <ul className="bottom-nav-content">

          <li>
              <NavLink
                to={{ pathname: "/#" }}
                onClick={window["liveChatButton"]}
                className="nav-link"
                activeClassName="active"
              >
                 <img
                      className="bottom-icon"
                      src={img["chat-icon-bottom-nav-mobile.webp"]}
                      alt="chat icon"
                    />
                    <img
                      className="bottom-icon-active"
                      src={img["chat-icon-bottom-nav-mobile-active.webp"]}
                      alt="chat icon active"
                    />
                {t("contact-us.live-chat")}
              </NavLink>
            </li>

            <li>
              <NavLink
                // to={{ pathname: `/online-live-games-${dynamicCountry}` }}
                to={{ pathname: "/" }}
                className="nav-link home-btn"
                activeClassName="active"
              >
                 <img
                      className="bottom-icon"
                      src={img["home-icon-bottom-nav-mobile.webp"]}
                      alt="home icon"
                    />
                    <img
                      className="bottom-icon-active"
                      src={img["home-icon-bottom-nav-mobile-active.webp"]}
                      alt="home icon active"
                    />
                {/* {t("profile-sidebar.home")} */}
              </NavLink>
            </li>

            <li>
              <NavLink
                to={{ pathname: "/contact-us" }}
                onClick={window["liveChatButton"]}
                className="nav-link"
                activeClassName="active"
              >
                 <img
                      className="bottom-icon"
                      src={img["contact-us.webp"]}
                      alt="chat icon"
                    />
                    <img
                      className="bottom-icon-active"
                      src={img["contact-us-active.webp"]}
                      alt="chat icon active"
                    />
                {t('sidebar.contact-us')}
              </NavLink>
            </li>

          </ul>
        </section>
      </Auxiliary>
    );  
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUser.data,
  };
};

const mapDispatchToProps = {
  getUserData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces("translation")(MobileBottomNav));
